import auth from './auth';
import user from './user';

export const en_auth = {
    auth,
    user
}